import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { StatusBanner } from 'web-ui-components/lib/layout/content';
import { ConfirmationModal } from 'web-ui-components/lib/organisms/modals';
import Table from '../Table/index';
import withContent from '../../containers/withContent';
import pageContent, { contentPropTypes } from './index.content';
import { getSelectedPayee } from '../../managePayee/states/selectors';
import { newPayeeDetailsPropTypes } from '../../payees/states/addPayeeSuccess/propTypes';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { StandardBody } from 'web-ui-components/lib/typography/body';

const mapState = (state) => ({
	deletePayeeDetails: getSelectedPayee(state),
});

export const DeleteConfirmationModal = ({
	deletePayeeDetails,
	isModalOpen,
	handleClose,
	confirmDeletePayee,
	content,
	hasApiCallInProgress,
	handleRoute,
}) => {
	const {
		dismissButtonLabel,
		confirmButtonLabel,
		deleteTemplateModalTitle,
		infoText,
		scheduledPayementInfoText,
		scheduledPayementLink,
	} = content;
	return (
		<ConfirmationModal
			titleText={deleteTemplateModalTitle}
			onConfirm={confirmDeletePayee}
			onClose={handleClose}
			isOpen={isModalOpen}
			dismissButtonText={dismissButtonLabel}
			confirmButtonText={confirmButtonLabel}
			confirmButtonIsDisabled={hasApiCallInProgress}
			dismissButtonIsDisabled={hasApiCallInProgress}
		>
			<StatusBanner.Information>
				<StandardBody>
					<p>
						<strong>{infoText}</strong>
					</p>
					<span>
						{scheduledPayementInfoText}
						 
						<NavigationButton.Tertiary
							isInline
							labelText={scheduledPayementLink}
							onClick={() => handleRoute('WEB-MANAGE-PAYMENT')}
							data-test-id="goToScheduledPaymentBtn"
						/>
					</span>
				</StandardBody>
			</StatusBanner.Information>

			<div className="u-margin-bottom-2">
				<Table content={content} newPayeeDetails={deletePayeeDetails} />
			</div>
		</ConfirmationModal>
	);
};

DeleteConfirmationModal.defaultProps = {
	isModalOpen: false,
};

DeleteConfirmationModal.propTypes = {
	isModalOpen: PropTypes.bool,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	confirmDeletePayee: PropTypes.func.isRequired,
	handleRoute: PropTypes.func.isRequired,
	deletePayeeDetails: PropTypes.shape(newPayeeDetailsPropTypes).isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
};

export default compose(connect(mapState), withContent({ content: pageContent }))(DeleteConfirmationModal);
